import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import styles from "./styles.module.scss";

interface VehicleVideoPopupProps {
  open: boolean;
  videoUrl: string;
  onClose: () => void;
}

const VehicleVideoPopup: React.FC<VehicleVideoPopupProps> = ({
  open,
  videoUrl,
  onClose,
}) => {
  const [panelIn, setPanelIn] = useState(false);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
      document.body.classList.add("scs-vehicle-video-open");
      const root = document.documentElement;
      root.style.setProperty("--scs-vv-available-h", `${window.innerHeight}px`);
      root.style.setProperty("--scs-vv-panel-max", `${window.innerHeight - 60}px`);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => setPanelIn(true));
      });
    } else {
      setPanelIn(false);
      document.body.style.overflow = "";
      document.body.classList.remove("scs-vehicle-video-open");
    }
    return () => {
      document.body.style.overflow = "";
      document.body.classList.remove("scs-vehicle-video-open");
      const root = document.documentElement;
      root.style.removeProperty("--scs-vv-available-h");
      root.style.removeProperty("--scs-vv-panel-max");
    };
  }, [open]);

  if (!open || !videoUrl) return null;

  return createPortal(
    <div
      className={styles.sheet}
      role="dialog"
      aria-modal="true"
      aria-label="Vehicle Video"
    >
      <button
        type="button"
        className={styles.backdrop}
        aria-label="Close video"
        onClick={onClose}
      />
      <div className={`${styles.panel} ${panelIn ? styles.panelIn : ""}`}>
        <div className={styles.handle} aria-hidden="true" />

        <header className={styles.head}>
          <h2 className={styles.title}>Seat Covers in Your Vehicle</h2>
        </header>

        <div className={styles.content}>
          <div className={styles.preview}>
            <iframe
              src={`${videoUrl}?autoplay=0&rel=0`}
              title="Seat covers in your vehicle"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className={styles.iframe}
            />
          </div>
        </div>
        <button type="button" className={styles.done} onClick={onClose}>
          Done, Looks Good
        </button>
      </div>
    </div>,
    document.body
  );
};

export default VehicleVideoPopup;
